var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","height":"600px"}},[_c('div',{staticStyle:{"width":"800px","left":"50%","flex-grow":"1","align-self":"center"}},[_c('img',{staticStyle:{"width":"200px","height":"200px"},attrs:{"src":"/static/images/logo.png","alt":""}}),_c('h2',[_vm._v(_vm._s(_vm.webname))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }